"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
window.Cookies = js_cookie_1.default;
;
(function (Drupal, once, cookies) {
    Drupal.behaviors.checkIfCtaBeenClosed = {
        attach: function (context) {
            once('checkIfCtaBeenClosed', 'body').forEach(function (element) {
                const callToAction = document.querySelector('.js-call-to-action');
                const openCallToAction = document.querySelector('.js-open-call-to-action');
                const callToActionBlockId = callToAction === null || callToAction === void 0 ? void 0 : callToAction.getAttribute('block-id');
                const ctaId = `cta-closed-${callToActionBlockId}`;
                let ctaIsClosed = false;
                if (cookies.get(ctaId)) {
                    ctaIsClosed = true;
                }
                if (!ctaIsClosed) {
                    // Open the call to action
                    if (callToAction) {
                        callToAction.classList.remove('hidden', 'pointer-events-none');
                        openCallToAction === null || openCallToAction === void 0 ? void 0 : openCallToAction.classList.add('hidden');
                    }
                }
                else {
                    if (callToAction) {
                        callToAction.classList.add('hidden', 'pointer-events-none');
                        openCallToAction === null || openCallToAction === void 0 ? void 0 : openCallToAction.classList.remove('hidden');
                    }
                }
            });
        },
    };
})(Drupal, once, window.Cookies);
